import axios from 'axios';
import { Item, Category, StoreInfo } from '../types';

// Base API URL - you can change this to your actual API endpoint
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

// For development, we'll use the real API if backend is running, otherwise fallback to mock
const MOCK_API = Boolean(process.env.USE_MOCK) || false; // Set to true to force mock API usage

// Mock data (same as your current sampleData)
const mockStoreInfo: StoreInfo = {
  name: "חיי קדושה",
  tagline: "לעילוי נשמת סמל ראשון חיים סבח",
  description: "טליתות ,תפילין ,כיסויים וכלל תשמישי הקדושה במחירים נוחים ואיכות הכי גבוהה בשוק",
  contact: {
    phone: "0508445564",
    email: "matanlior@gmail.com",
    address: "תמר 10 או סמטת הורד 2"
  }
};

const mockCategories: Category[] = [
  { id: 1, name: "Sacred Objects", description: "Religious artifacts and sacred items" },
  { id: 2, name: "Prayer Items", description: "Prayer books, rosaries, and devotional tools" },
  { id: 3, name: "Home Decor", description: "Religious home decorations and artwork" },
  { id: 4, name: "Jewelry", description: "Religious jewelry and accessories" },
  { id: 5, name: "Clothing", description: "Religious clothing and ceremonial garments" },
  { id: 6, name: "Gifts", description: "Religious gifts and keepsakes" }
];

const mockItems: Item[] = [
  {
    id: 1,
    title: "טלית",
    description: "טלית יפה בעבודת יד מעץ זית, מושלמת לאלטר הבית או למקום מדיטציה.",
    price: 89,
    image: "https://pub-40f911f4a0fc49e2bf7c15ae026fa6a3.r2.dev/talit.jpeg",
    category: "טליתות",
    sku: "HC-CROSS-001",
    isInStock: true
  },
  {
    id: 2,
    title: "Crystal Prayer Beads",
    description: "108 crystal prayer beads for meditation and spiritual practice, crafted with natural amethyst.",
    price: 65.99,
    image: "/api/placeholder/300/400",
    category: "Prayer Items",
    sku: "SS-BEADS-001",
    isInStock: true
  },
  {
    id: 3,
    title: "Virgin Mary Statue",
    description: "Exquisite porcelain Virgin Mary statue, hand-painted with intricate details and gold accents.",
    price: 149.99,
    image: "/api/placeholder/300/400",
    category: "Sacred Objects",
    sku: "DA-MARY-001",
    isInStock: false
  },
  {
    id: 4,
    title: "Holy Water Font",
    description: "Elegant marble holy water font with silver-plated basin, perfect for home blessing.",
    price: 75.99,
    image: "/api/placeholder/300/400",
    category: "Home Decor",
    sku: "SH-FONT-001",
    isInStock: true
  },
  {
    id: 5,
    title: "Gold Cross Pendant",
    description: "18k gold cross pendant on a delicate chain, a timeless symbol of faith and devotion.",
    price: 199.99,
    image: "/api/placeholder/300/400",
    category: "Jewelry",
    sku: "DJ-CROSS-001",
    isInStock: true
  },
  {
    id: 6,
    title: "Prayer Shawl",
    description: "Hand-woven prayer shawl in traditional colors, perfect for religious ceremonies and meditation.",
    price: 125.99,
    image: "/api/placeholder/300/400",
    category: "Clothing",
    sku: "ST-SHAWL-001",
    isInStock: false
  },
  {
    id: 1,
    title: "טלית",
    description: "טלית יפה בעבודת יד מעץ זית, מושלמת לאלטר הבית או למקום מדיטציה.",
    price: 89.99,
    image: "https://pub-40f911f4a0fc49e2bf7c15ae026fa6a3.r2.dev/talit.jpeg",
    category: "טליתות",
    sku: "HC-CROSS-001",
    isInStock: true
  },
  {
    id: 2,
    title: "Crystal Prayer Beads",
    description: "108 crystal prayer beads for meditation and spiritual practice, crafted with natural amethyst.",
    price: 65.99,
    image: "/api/placeholder/300/400",
    category: "Prayer Items",
    sku: "SS-BEADS-001",
    isInStock: true
  },
  {
    id: 3,
    title: "Virgin Mary Statue",
    description: "Exquisite porcelain Virgin Mary statue, hand-painted with intricate details and gold accents.",
    price: 149.99,
    image: "/api/placeholder/300/400",
    category: "Sacred Objects",
    sku: "DA-MARY-001",
    isInStock: false
  },
  {
    id: 4,
    title: "Holy Water Font",
    description: "Elegant marble holy water font with silver-plated basin, perfect for home blessing.",
    price: 75.99,
    image: "/api/placeholder/300/400",
    category: "Home Decor",
    sku: "SH-FONT-001",
    isInStock: true
  },
  {
    id: 5,
    title: "Gold Cross Pendant",
    description: "18k gold cross pendant on a delicate chain, a timeless symbol of faith and devotion.",
    price: 199.99,
    image: "/api/placeholder/300/400",
    category: "Jewelry",
    sku: "DJ-CROSS-001",
    isInStock: true
  },
  {
    id: 6,
    title: "Prayer Shawl",
    description: "Hand-woven prayer shawl in traditional colors, perfect for religious ceremonies and meditation.",
    price: 125.99,
    image: "/api/placeholder/300/400",
    category: "Clothing",
    sku: "ST-SHAWL-001",
    isInStock: false
  }
];

// Utility function to simulate API delay
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// API Service Class
export class ApiService {
  private baseUrl: string;

  constructor(baseUrl: string = API_BASE_URL) {
    this.baseUrl = baseUrl;
  }

  // Generic fetch method with error handling
  private async fetchData<T>(endpoint: string): Promise<T> {
    if (MOCK_API) {
      // Simulate API delay
      await delay(500 + Math.random() * 1000);
      return this.getMockData<T>(endpoint);
    }

    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw new Error(`Failed to fetch data from ${endpoint}`);
    }
  }

  // Get mock data based on endpoint
  private getMockData<T>(endpoint: string): T {
    switch (endpoint) {
      case '/api/storeInfo':
        return mockStoreInfo as T;
      case '/api/categories':
        return mockCategories as T;
      case '/api/items':
        return mockItems as T;
      default:
        throw new Error(`Unknown endpoint: ${endpoint}`);
    }
  }

  // Store Info API
  async getStoreInfo(): Promise<StoreInfo> {
    return this.fetchData<StoreInfo>('/api/storeInfo');
  }

  // Categories API
  async getCategories(): Promise<Category[]> {
    return this.fetchData<Category[]>('/api/categories');
  }

  // Items API
  async getItems(): Promise<Item[]> {
    return this.fetchData<Item[]>('/api/items');
  }
  async getGallery(): Promise<string[]> {
    if (MOCK_API) {
      return [
        "https://pub-40f911f4a0fc49e2bf7c15ae026fa6a3.r2.dev/talit.jpeg",
        "https://pub-40f911f4a0fc49e2bf7c15ae026fa6a3.r2.dev/talit.jpeg"
      ];
    }
    return axios.get(this.baseUrl + '/api/storeInfo/gallery').then(response => response.data);
  }
  // Get item by ID
  async getItemById(id: number): Promise<Item> {
    const items = await this.getItems();
    const item = items.find(item => item.id === id);

    if (!item) {
      throw new Error(`Item with ID ${id} not found`);
    }

    return item;
  }

  // Get items by category
  async getItemsByCategory(categoryName: string): Promise<Item[]> {
    const items = await this.getItems();
    return items.filter(item => item.category === categoryName);
  }

  // Search items
  async searchItems(query: string): Promise<Item[]> {
    const items = await this.getItems();
    const lowercaseQuery = query.toLowerCase();

    return items.filter(item =>
      item.title.toLowerCase().includes(lowercaseQuery) ||
      item.description.toLowerCase().includes(lowercaseQuery)
    );
  }
}

// Create and export a default instance
export const apiService = new ApiService();

// Export types for use in components
export type { Item, Category, StoreInfo };
